module.exports = __webpack_public_path__ + "img/location-singapore-5.02765368.jpg";